import 'normalize.css';
import '../styles/globals.css';
import '@reviewshake-app/shake-ui/dist/shake-ui.css';
import { AppProps } from 'next/app';

const App = ({ Component, pageProps }: AppProps): JSX.Element => <Component {...pageProps} />;

export default App;
